import React, { useState } from 'react';
import { ChevronRightIcon } from '@heroicons/react/24/outline';

interface DropdownItemData {
  id: string;
  name: string;
  count?: number;
  children?: DropdownItemData[];
  industries?: DropdownItemData[];
}

interface DropdownItemProps {
  id: string;
  name: string;
  children?: DropdownItemData[];
  checked: boolean;
  onChange: (id: string, checked: boolean) => void;
  level?: number;
}

export const DropdownItem: React.FC<DropdownItemProps> = ({
  id,
  name,
  children = [],
  checked,
  onChange,
  level = 0
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const hasChildren = children.length > 0;

  const handleToggle = () => {
    onChange(id, !checked);
  };

  const handleExpand = () => {
    if (hasChildren) {
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <div className="w-full">
      <div 
        className="flex items-center py-2 px-2 hover:bg-gray-50 cursor-pointer"
        style={{ 
          paddingLeft: `${8 + level * 20}px`
        }}
      >
        {/* Expand/Collapse Arrow */}
        {hasChildren && (
          <button
            onClick={handleExpand}
            className="mr-2 p-1 hover:bg-gray-200 rounded"
          >
            <ChevronRightIcon 
              className={`h-4 w-4 text-gray-500 transition-transform ${
                isExpanded ? 'rotate-90' : ''
              }`} 
            />
          </button>
        )}

        {/* Checkbox - для дочерних элементов слева, для родительских справа */}
        {level === 0 ? (
          // Родительский элемент - чекбокс справа
          <>
            {/* Item Name */}
            <div 
              className="flex-1 text-sm text-gray-700 cursor-pointer"
              onClick={hasChildren ? handleExpand : handleToggle}
            >
              {name}
            </div>
            {/* Checkbox справа */}
            <div className="flex items-center ml-3">
              <input
                type="checkbox"
                checked={checked}
                onChange={handleToggle}
                className="h-4 w-4 text-[#e16349] border-gray-300 rounded focus:ring-[#e16349]"
              />
            </div>
          </>
        ) : (
          // Дочерний элемент - чекбокс слева
          <>
            {/* Checkbox слева */}
            <div className="flex items-center mr-3">
              <input
                type="checkbox"
                checked={checked}
                onChange={handleToggle}
                className="h-4 w-4 text-[#e16349] border-gray-300 rounded focus:ring-[#e16349]"
              />
            </div>
            {/* Item Name */}
            <div 
              className="flex-1 text-sm text-gray-700 cursor-pointer"
              onClick={handleToggle}
            >
              {name}
            </div>
          </>
        )}
      </div>

      {/* Children */}
      {hasChildren && isExpanded && (
        <div className="w-full">
          {children.map((child) => (
            <DropdownItem
              key={child.id}
              id={child.id}
              name={child.name}
              children={child.children}
              checked={false} // Дети не имеют состояния checked, они управляются родителем
              onChange={onChange}
              level={level + 1}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default DropdownItem;
